import { css } from 'styled-components'

export const links = {
  links: css`
    text-decoration: none;
    transition: all 0.3s;
    font-weight: 300;
  `,
}
